import { constants, actions } from 'ducks-helpers';

//  SUFFIXES
// [
//   'LOADING',
//   'PENDING',
//   'SUCCESS',
//   'ERROR',
//   'FAILED',
//   'CANCELED'
// ]

export const TYPE = constants('admin/service_centers', [
    '~FETCH_SERVICE_CENTERS',
    '~PREPARE_FILTER',

    /** EDIT ACTIONS */
    'EDIT',
    'TOGGLE_EDIT_MODAL',
    'SUBMIT_EDIT',
    /** */
]);

export const ACTION = actions(TYPE);
